export const partnerBrands = [
  { name: '蒙牛', logo: '/images/partner-mengniu.jpeg' },
  { name: '白象', logo: '/images/partner-baixiang.jpg' },
  { name: '百事', logo: '/images/partner-baishi.jpg' },
  { name: '康师傅', logo: '/images/partner-kangshifu.jpeg' },
  { name: '蓝带', logo: '/images/partner-landai.jpg' },
  { name: '立白', logo: '/images/partner-libai.jpg' },
  { name: '妙可蓝多', logo: '/images/partner-miaokelanduo.jpg' },
  { name: '盼盼', logo: '/images/partner-panpan.jpg' },
  { name: '王老吉', logo: '/images/partner-wanglaoji.jpeg' },
  { name: '旺旺', logo: '/images/partner-wangwang.jpg' },
  { name: '百味佳', logo: '/images/partner-baiweijia.jpg' },
  { name: '冰峰', logo: '/images/partner-bingfeng.jpg' },
  { name: '东古', logo: '/images/partner-donggu.jpg' },
  { name: '二次方', logo: '/images/partner-ercifang.jpg' },
  { name: '嘉士伯', logo: '/images/partner-jiashibo.jpg' },
  { name: '健力宝', logo: '/images/partner-jianlibao.jpg' },
  { name: '能量森林', logo: '/images/partner-nengliangsenlin.jpg' },
  { name: '派斯力', logo: '/images/partner-paisili.jpg' },
  { name: '轻上', logo: '/images/partner-qingshang.jpg' },
];

export const trustStats = [
  { number: '12', suffix: '+', label: '服务头部快消品牌' },
  { number: '6', suffix: '+', label: '覆盖细分行业' },
  { number: '10', suffix: '年+', label: '快消数字化深耕' },
  { number: '100', suffix: '%', label: '项目按时交付承诺' },
];

export const operationalCapabilities = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: '营销数字化战略&咨询',
    description: '数字化创新赋能企业显著提升业务价值。由资深专家团队深度诊断企业营销管理痛点，输出可落地的数字化转型路径规划。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '营销数字化运营陪跑',
    description: '营销策略研究、营销数字化运营体系建设。上线后持续支持，确保系统真正用起来、用出效果。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '大数据运营服务',
    description: '沉淀用户数据，实现精细化运营。将系统沉淀的终端数据转化为可执行的营销洞察，持续优化营销策略与资源配置。',
  },
];

export const technicalCapabilities = [
  {
    icon: 'ri-layout-masonry-line',
    title: '五位一体营销数字化平台搭建',
    description: '用创新理念、智能技术和深厚行业经验，加速企业营销数字化转型。基于物码的"五位一体"解决方案，打通F/B/b/C及业务员五个核心角色。',
  },
  {
    icon: 'ri-apps-line',
    title: 'bC一体化SaaS系统',
    description: '包含生码系统、消费者互动营销平台、终端商户会员系统、经销商管理系统，打通品牌、渠道、消费者全链路数字闭环。',
  },
];

export const methodologySteps = [
  {
    num: '①',
    title: '营销数字化战略&咨询',
    desc: '深度诊断痛点，制定符合快消特性的转型路径，数字化创新赋能企业显著提升业务价值',
  },
  {
    num: '②',
    title: '营销数字化运营陪跑',
    desc: '营销策略研究、营销数字化运营体系建设，确保系统真正用起来、用出效果',
  },
  {
    num: '③',
    title: '五位一体平台搭建',
    desc: '加速企业营销数字化转型，构建连接品牌、渠道与消费者的完整数字化营销闭环',
  },
  {
    num: '④',
    title: 'bC一体化SaaS部署',
    desc: '包含生码系统、消费者互动营销平台、终端商户会员系统、经销商管理系统',
  },
  {
    num: '⑤',
    title: '大数据运营服务',
    desc: '沉淀用户数据，实现精细化运营，数据转化为可执行的营销洞察',
  },
];